import BaseLayer from "./BaseLayer";
import {drawCircle, drawLine, getHighestFocusPoint, mapMotorToCanvas} from "../utils/map_utils";
import {tileViewerPlotColors, zProfileFolderPath} from "../../../utils/const";
import React from "react";
import {Grid, Stack} from "@mui/material";
import {getPrefixedUrl} from "../../../utils/utils";
import {getFinalPlotData, getPlotPopup} from "./TileLayersUtils";

class TiltFocusPoints extends BaseLayer {
    id = "tiltFocusPoints";
    label = "Tilt Focus Points";
    defaultVisible = this.props.tileViewerState[this.id];

    onFeatureSelect = () => undefined;

    getDicy = (focusUnit) => null;

    draw = () => new Promise((resolve, reject) => {
        let {
            tiltFocusPoints,
            focusProfile,
            countyTiltInfo,
            deviceSettings,
            focusDirPath,
            focusOffset,
            textColor,
            textSize,
            focusImgPath,
            focusPlots,
            tileFlag
        } = this.props;
        let {loc_on_machine, tile_viewer_path, bucket_name} = this.props.slide;
        let xOffset = focusOffset['xy']["x_offset"];
        let yOffset = focusOffset['xy']["y_offset"];
        let highestPoint = getHighestFocusPoint(tiltFocusPoints, focusProfile, countyTiltInfo);
        for (const focusUnit of tiltFocusPoints) {
            let motorX = focusUnit['focusedAt']['xPosition'] - xOffset;
            let motorY = focusUnit['focusedAt']['yPosition'] - yOffset;
            let {x, y} = mapMotorToCanvas(motorX, motorY, this.props.slide, {device_settings: deviceSettings});
            let {y_fields, tile_height, uperpixel} = this.props.slide;
            if (tileFlag['reverseYTileOrder']['flagY'])
                y = y_fields * (tile_height * uperpixel) - y;
            let zProfilePath = '', zdiff;
            for (let l = 0; l < focusDirPath.focus_profile_dir_paths.length; l++) {
                const path = focusDirPath.focus_profile_dir_paths[l].split("_");
                const lastElement = path.pop();
                if (focusUnit['unifiedFocusId'] === parseInt(lastElement)) {
                    zProfilePath = focusDirPath.focus_profile_dir_paths[l];
                }
            }
            Object.values(focusPlots).forEach(val => {
                if (focusUnit['unifiedFocusId'] === parseInt(val['index'])) {
                    let finalPlotData = getFinalPlotData(val);
                    let popup = getPlotPopup(zProfilePath, finalPlotData, val['index']);
                    zdiff = focusUnit['focusedDown'] - highestPoint;
                    // zdiff is negative (means pt is down wrt highest pt)
                    zdiff = Math.round((zdiff + Number.EPSILON) * 100) / 100;
                    drawLine(x, y - 0.45 * tile_height * uperpixel, 1, this.layer.getSource(), zdiff,
                        10, "#E9D6C5", popup, textColor, textSize);
                }
            });
            let imgLink = '';
            Object.values(focusImgPath).forEach(val => {
                if (focusUnit['unifiedFocusId'] === parseInt(val['index'])) {
                    imgLink = getPrefixedUrl(`debug/zprofile/${val["img"]}`, this.props.slide, true);
                }
            });
            let link = "app://" + loc_on_machine + "/scans/" + bucket_name + "/" + tile_viewer_path + zProfileFolderPath + zProfilePath;
            let popupText = (
                <Stack>
                    <Grid>{"Tilt Focus Point"}</Grid>
                    <Grid>{"X:" + focusUnit['focusedAt']["xPosition"]}</Grid>
                    <Grid>{"Y:" + focusUnit['focusedAt']["yPosition"]}</Grid>
                    <Grid>{"focusedUp:" + focusUnit['focusedUp']}</Grid>
                    <Grid>{"focusedDown:" + focusUnit['focusedDown']}</Grid>
                    <Grid>
                        <a href={link}>{"ID " + focusUnit['unifiedFocusId'] + " Location"}</a>
                        <a href={imgLink} target={"_blank"}>{" [Img Link]"}</a>
                    </Grid>
                    <Grid>{"The displayed value is Δz=" + zdiff}</Grid>
                    <Grid>{"Click on Δz Value to open the focus plot"}</Grid>
                </Stack>
            );
            drawCircle(x, y, 0.4 * tile_height * uperpixel, this.layer.getSource(), "", 16,
                tileViewerPlotColors.tiltFocusPointBlueColor, popupText, textColor);
            this.getDicy(focusUnit);
        }
        resolve();
    });
}

export default TiltFocusPoints;